<template>
  <div class="goal-settings-page">
    <!-- TODO: flexbox layout -->
    <div class="goal-settings-page-sidebar p-4 d-flex flex-column">
      <el-menu
        default-active="1"
        @select="onSelectMenuItem">
        <div style="margin: 1em">
          <h5><i class="el-icon-setting"></i> Settings</h5>
        </div>
        <el-menu-item index="1">
          <span>General Settings</span>
        </el-menu-item>
        <el-menu-item index="2">
          <span>Description</span>
        </el-menu-item>
        <el-menu-item index="3" :disabled="!goal_meta.isTeamgoal">
          <span>Members</span>
        </el-menu-item>
        <!--
        <el-menu-item index="4" :disabled="!goal_meta.isTeamgoal">
          <span>Privacy settings</span>
        </el-menu-item>
        <el-menu-item index="5">
          <span>Deadlines</span>
        </el-menu-item>
        <el-menu-item index="6">
          <span>Commitments</span>
        </el-menu-item>
        <el-menu-item index="7">
          <span>Info</span>
        </el-menu-item>
        -->
      </el-menu>
      <el-button class="btn-block" style="margin-top: auto" @click="onGoToGoal">Go back to goal</el-button>
    </div>
    <div class="goal-settings-page-content py-4 pr-4">
      <div v-if="goal_meta.$ready">

        <el-card v-if="selected_menu_item === 1">
          <GoalConfig :goal-id="goal_id" />
        </el-card>

        <el-card v-if="selected_menu_item === 2">
          <GoalDescriptionConfig :goal-id="goal_id" />
        </el-card>

        <el-card v-if="selected_menu_item === 3">
          <GoalMemberConfig :goal-id="goal_id" />
        </el-card>

        <!--
        <el-card v-if="selected_menu_item === 4">
          <GoalPrivacyConfig :goal-id="goal_id" />
        </el-card>

        <el-card v-if="selected_menu_item === 5">
          <GoalDeadlineConfig :goal-id="goal_id" />
        </el-card>

        <el-card v-if="selected_menu_item === 6">
          <GoalCommitmentConfig :goal-id="goal_id" />
        </el-card>
        -->

        <el-tabs
          v-if="selected_menu_item === 7"
          type="border-card"
          v-model="selectedTabName">

          <el-tab-pane label="Tasks" name="tasks">
            <!--
            <el-row>
              <ul>
                <li v-for="(task, taskId) in goalTasks" :key="taskId">
                  <font-awesome-icon :icon="task.done ? 'check-square': 'square'" fal class="symbol" />
                  {{task.name}} ({{task.description}})
                </li>
              </ul>
            </el-row>
            -->
            <a href="#" @click.prevent="onGoToKanban">Go to Kanban board</a> to add, edit and delete tasks
            or <a href="#" @click.prevent="onGoToGoal">Go to goal page</a>
          </el-tab-pane>

          <el-tab-pane label="Invite People" name="invite">
            <el-row>
              To invite people go to Kanbard board. Click on goal settings and turn goal into "team lane". There you can invite people.

              <a href="#" @click.prevent="onGoToGoal">Go to goal page</a>.
            </el-row>
          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
    <div style="position: absolute; top: 0; right: 0.5em;">
      <button class="close px-2 clickable" aria-label="Close" @click="onGoToGoal">
        <span aria-hidden="true" style="font-size: 200%">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import GoalConfig from '@/components/Config/Goal/GoalConfig'
import GoalMemberConfig from '@/components/Config/Goal/GoalMemberConfig'
import GoalDescriptionConfig from '@/components/Config/Goal/GoalDescriptionConfig'
// import GoalDeadlineConfig from '@/components/Config/Goal/GoalDeadlineConfig'
// import GoalCommitmentConfig from '@/components/Config/Goal/GoalCommitmentConfig'
// import GoalPrivacyConfig from '@/components/Config/Goal/GoalPrivacyConfig'

// TODO: Teamlane => Teamgoal

// TODO: Split Settings in more subsections
// TODO: Allow to book additional packages here

export default {
  name: "SettingsSubpage",
  data: () => ({
    selected_menu_item: 1,
    selectedTabName: 'tasks'
  }),
  computed: {
    goal_id() {
      return this.$route.params.goalId;
    },
    goal_meta() {
      return this.$models.goalMeta.subscribeNode( this.goal_id );
    },
  },
  methods: {

    onSelectMenuItem(key, keyPath) {
      this.selected_menu_item = parseInt( key );
    },

    onGoToKanban() {
      this.$router.push('/goal/' + this.goal_id + '/kanban');
    },

    onGoToGoal() {
      this.$router.push('/goal/' + this.goal_id);
    },
  },
  components: {
    GoalConfig,
    GoalMemberConfig,
    GoalDescriptionConfig,
    // GoalCommitmentConfig,
    // GoalDeadlineConfig,
    // GoalPrivacyConfig,
  }
};
</script>

<style>
.goal-settings-page {
  display: flex;
  margin: 0 4em;
  border: 0 solid black;
  border-radius: 5px;
  margin-top: 1em;
  background-color: #ffffffbd;
  padding-top: 30px;
  position: relative;
}
.goal-settings-page .goal-settings-page-sidebar {
  width: 200px;
}
.goal-settings-page .goal-settings-page-sidebar .el-card__body,
.goal-settings-page .goal-settings-page-sidebar .el-menu {
  background-color: unset;
  border: none;
}
.goal-settings-page .goal-settings-page-content {
  flex: auto;
  background-color: unset;
}
.goal-settings-page .goal-settings-page-content > div {
  overflow: auto;
  max-height: calc(100vh - 151px);
}
</style>
